export const BULK_VIEW_PAGE_SIZE = 20;
export const BULK_VIEW_COLUMN_SIZING_LS_KEY = 'annotation-queue-bulk-view';
export const ANNOTATION_QUEUE_COLLAB_SETTINGS_DOCS_HREF =
  'https://docs.langchain.com/langsmith/annotation-queues#collaborator-settings';
